import { jsxs as o, jsx as l } from "react/jsx-runtime";
import { getIconStyles as e } from "../styles.js";
const n = (C) => /* @__PURE__ */ o(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: e(C),
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          d: "M10.65 6.35C10.65 5.60442 11.2544 5 12 5C12.7456 5 13.35 5.60442 13.35 6.35V12.15C13.35 12.8956 12.7456 13.5 12 13.5C11.2544 13.5 10.65 12.8956 10.65 12.15V6.35Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M13.625 17C13.625 17.8975 12.8975 18.625 12 18.625C11.1025 18.625 10.375 17.8975 10.375 17C10.375 16.1025 11.1025 15.375 12 15.375C12.8975 15.375 13.625 16.1025 13.625 17Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
export {
  n as CircleAlertIcon
};
//# sourceMappingURL=CircleAlertIcon.js.map
